import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { CustomMuiThemeProvider } from 'theme/CustomMuiThemeProvider';

export const ErrorBoundaryFallback = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <CustomMuiThemeProvider>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          bgcolor: 'background.default',
        }}
      >
        <Box
          sx={{
            maxWidth: 440,
            textAlign: 'center',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 3,
            bgcolor: 'background.paper',
            p: 5,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
          <Typography variant="h6" fontWeight={700} gutterBottom>
            {t('error_boundary_title')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {t('error_boundary_body')}
          </Typography>
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={() => {
              window.location.reload();
            }}
            sx={{ borderRadius: '8px', fontWeight: 600 }}
          >
            {t('error_boundary_reload')}
          </Button>
        </Box>
      </Box>
    </CustomMuiThemeProvider>
  );
};
